import { render } from "./showImage.vue?vue&type=template&id=ecb332cc&scoped=true&ts=true"
import script from "./showImage.vue?vue&type=script&lang=ts"
export * from "./showImage.vue?vue&type=script&lang=ts"

import "./showImage.vue?vue&type=style&index=0&id=ecb332cc&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb332cc"]])

export default __exports__